// Components
import { BaseTable, FooterMenu, HeaderMenu, Loading, PermissionLink, Select, TableHeader } from "components";

// Icons
import { IoSendSharp } from "react-icons/io5";

// Third-Party Libraries
import moment from "moment";

// Utils
import { convertNumber } from "utils";
import { default_option } from "pages/Purchase/Register/utils";
import { billStatusList } from "../EnterBill/utils";
import { statusList, useList } from "./utils";
import { PERMISION } from "security";

export default function RecordReject(): JSX.Element {
  // Hooks
  const { data, isLoading, statusReject, setStatusReject } = useList();

  return (
    <div className="container my-5 flex flex-col gap-3">
      <HeaderMenu title="DATA ENTRY | REJECTED RECORDS" />

      <div className="w-[300px]">
        <Select
          label="REJECT STATUS"
          placeholder="Select Status"
          options={statusList}
          value={statusList.find((item) => item.value === statusReject) ?? null}
          onChange={(e) => setStatusReject(e?.value ?? "")}
        />
      </div>
      <div className="overflow-x-auto max-h-[calc(100vh-480px)]">
        <BaseTable>
          <TableHeader>
            <tr>
              <th>NO</th>
              <th colSpan={2}>PROJECT ID#</th>
              <th>DATE</th>
              <th>LINK BILL ID#</th>
              <th>VENDOR</th>
              <th>REJECTED QTY</th>
              <th>TOTAL</th>
              <th>LOCATION</th>
              <th>MEMO</th>
              <th>APPROVAL STATUS</th>
              <th>STATUS: REJECTED</th>
            </tr>
          </TableHeader>

          <tbody>
            {isLoading || !data.length ? (
              <tr>
                <td colSpan={12}>
                  <Loading errorText="No data available" loading={isLoading} />
                </td>
              </tr>
            ) : (
              data.map((item, key) => (
                <tr key={key}>
                  <td className="text-center">{key + 1}</td>

                  <td>
                    <PermissionLink
                      permission={PERMISION.PURCHASES.TRANSACTION.CREATE_REJECTED_RECORDS.UPDATE}
                      to={`/purchase/transaction/record-reject/${item.reject_id}`}
                    >
                      <IoSendSharp />
                    </PermissionLink>
                  </td>

                  <td>{item.trx_code}</td>
                  <td>{moment(item.transaction_date).format("DD/MM/YYYY")}</td>
                  <td>{item.trx_bill_code}</td>
                  <td>{item.vendor_name}</td>
                  <td className="text-center">{convertNumber(item.qty).intoCurrency}</td>
                  <td>{convertNumber(item.total).intoCurrency}</td>
                  <td>{item.location_name}</td>
                  <td>{item.memo}</td>
                  <td>
                    {default_option.find(
                      (i) => i.value === item.approve_status.toString()
                    )?.label ?? "-"}
                  </td>
                  <td>{billStatusList[item.reject_status.toString()]}</td>
                </tr>
              ))
            )}
          </tbody>
        </BaseTable>
      </div>
      <FooterMenu />
    </div>
  );
}
